// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__zEQu6","footerText":"Footer_footerText__dhxMc","companyName":"Footer_companyName__EjSee"};